import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'

export const PropertiesContent = styled(Flex)`
  overflow-y: auto;
`
